























import { throttle } from 'lodash-es'
import SharedReportAsset from './SharedReportAsset.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    SharedReportAsset
  }
})
export default class AssetAccordion extends Vue {
  @Prop() assets!:any
  @Prop() assetOrder!:any
  @Prop() editable!:any
  @Prop() qualNotable!:any
  @Prop() drop!:any

  get assetsVisible ():any {
    return this.assetOrder.reduce((acc:any, key:any) => {
      acc[key] = true
      return acc
    }, {})
  }

  get assetList ():any {
    return this.assetOrder.filter((key:any) => this.editable || this.shouldRenderAsset(key))
  }

  toggleAsset () {
    const that = this
    throttle(function (key:any, index:any, $event:any) {
      that.assetsVisible[key] = !that.assetsVisible[key]
    }, 50, { trailing: false })
  }

  isAssetVisible (key:string):any {
    return this.assetsVisible[key]
  }

  moveAsset (index:any, direction:any) {
    this.$emit('moveAsset', { index: index, direction: direction })
  }

  shouldRenderAsset (key:any):any {
    const asset = this.assets[key]
    // eslint-disable-next-line no-prototype-builtins
    return asset.editable || (asset.hasOwnProperty('export') && asset.export) || (!asset.hasOwnProperty('export') && !asset.nonExport) // backwards compatibility
  }

  updateAsset ({ asset, key }:any) {
    this.$emit('updateAsset', { asset, key })
  }
}
